"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const InputSelect = ({ id, onValueChange = undefined, value = undefined, defaultValue = '', noBlank = false, choices = [], localePrefix = 'main', t = (_str) => '', disabled = false }) => {
    const actualValue = value === undefined ? defaultValue : value;
    const defaultAttributes = {
        name: id,
        id: id,
        value: actualValue
    };
    if (onValueChange) {
        defaultAttributes.onChange = onValueChange;
    }
    if (disabled === true) {
        defaultAttributes.disabled = true;
    }
    const selectChoices = [];
    for (let i = 0, count = choices.length; i < count; i++) {
        const choice = choices[i];
        if (choice.choices) {
            const childChoices = choice.choices.map((childChoice) => {
                return (react_1.default.createElement("option", { key: `${childChoice.value}`, value: childChoice.value, disabled: choice.disabled }, childChoice.label || t(`${localePrefix}:${childChoice.value}`)));
            });
            selectChoices.push(react_1.default.createElement("optgroup", { key: `group_${choice.value}`, label: choice.label || t(`${localePrefix}:${choice.value}`) }, childChoices));
        }
        else {
            selectChoices.push(react_1.default.createElement("option", { key: `${choice.value}`, value: choice.value, disabled: choice.disabled }, choice.label || t(`${localePrefix}:${choice.value}`)));
        }
    }
    return (react_1.default.createElement("select", Object.assign({ autoComplete: "none", className: "tr__form-input-select apptr__input _input-select" }, defaultAttributes, { style: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        } }),
        !noBlank && react_1.default.createElement("option", { key: '_blank', value: "" }),
        selectChoices));
};
exports.default = InputSelect;
//# sourceMappingURL=InputSelect.js.map